// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__1w8gD","ChangeUserModal":"styles_ChangeUserModal__Jt20B","closeButton":"styles_closeButton__e+Z2G","title":"styles_title__G4eIr"};